import React, { useState } from 'react';
import { BusinessInformation as BusinessInformationType, BusinessInformationProps } from '../types';

export const BusinessInformation: React.FC<BusinessInformationProps> = ({ businessInfo, onUpdate }) => {
  const [formData, setFormData] = useState<BusinessInformationType>(businessInfo);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleKeywordAdd = () => {
    const newKeyword = (document.getElementById('keyword') as HTMLInputElement).value;
    if (newKeyword.trim()) {
      setFormData(prev => ({
        ...prev,
        keywords: [...prev.keywords, newKeyword.trim()]
      }));
      (document.getElementById('keyword') as HTMLInputElement).value = '';
    }
  };

  const handleKeywordRemove = (index: number) => {
    setFormData(prev => ({
      ...prev,
      keywords: prev.keywords.filter((_, i) => i !== index)
    }));
  };

  const handleCompetitorAccountAdd = () => {
    const newAccount = (document.getElementById('competitorAccount') as HTMLInputElement).value;
    if (newAccount.trim()) {
      setFormData(prev => ({
        ...prev,
        competitorAccounts: [...prev.competitorAccounts, newAccount.trim()]
      }));
      (document.getElementById('competitorAccount') as HTMLInputElement).value = '';
    }
  };

  const handleCompetitorAccountRemove = (index: number) => {
    setFormData(prev => ({
      ...prev,
      competitorAccounts: prev.competitorAccounts.filter((_, i) => i !== index)
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onUpdate(formData);
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-2xl font-bold mb-6">Business Information</h1>
      <form onSubmit={handleSubmit} className="max-w-2xl">
        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Business Type
          </label>
          <div className="flex space-x-4">
            <button
              type="button"
              className={`px-4 py-2 rounded ${
                formData.businessType === 'b2b'
                  ? 'bg-blue-600 text-white'
                  : 'bg-gray-200 text-gray-700'
              }`}
              onClick={() => setFormData(prev => ({ ...prev, businessType: 'b2b' }))}
            >
              B2B
            </button>
            <button
              type="button"
              className={`px-4 py-2 rounded ${
                formData.businessType === 'b2c'
                  ? 'bg-blue-600 text-white'
                  : 'bg-gray-200 text-gray-700'
              }`}
              onClick={() => setFormData(prev => ({ ...prev, businessType: 'b2c' }))}
            >
              B2C
            </button>
          </div>
        </div>

        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Industry
          </label>
          <input
            type="text"
            name="industry"
            value={formData.industry}
            onChange={handleInputChange}
            className="w-full px-3 py-2 border rounded"
          />
        </div>

        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Target Audience
          </label>
          <input
            type="text"
            name="targetAudience"
            value={formData.targetAudience}
            onChange={handleInputChange}
            className="w-full px-3 py-2 border rounded"
          />
        </div>

        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Keywords
          </label>
          <div className="flex space-x-2 mb-2">
            <input
              type="text"
              id="keyword"
              className="flex-1 px-3 py-2 border rounded"
              placeholder="Add a keyword"
            />
            <button
              type="button"
              onClick={handleKeywordAdd}
              className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
            >
              Add
            </button>
          </div>
          <div className="flex flex-wrap gap-2">
            {formData.keywords.map((keyword, index) => (
              <span
                key={index}
                className="inline-flex items-center px-3 py-1 rounded-full text-sm bg-gray-100"
              >
                {keyword}
                <button
                  type="button"
                  onClick={() => handleKeywordRemove(index)}
                  className="ml-2 text-gray-500 hover:text-gray-700"
                >
                  ×
                </button>
              </span>
            ))}
          </div>
        </div>

        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Competitor Accounts
          </label>
          <div className="flex space-x-2 mb-2">
            <input
              type="text"
              id="competitorAccount"
              className="flex-1 px-3 py-2 border rounded"
              placeholder="Add a competitor account"
            />
            <button
              type="button"
              onClick={handleCompetitorAccountAdd}
              className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
            >
              Add
            </button>
          </div>
          <div className="flex flex-wrap gap-2">
            {formData.competitorAccounts.map((account, index) => (
              <span
                key={index}
                className="inline-flex items-center px-3 py-1 rounded-full text-sm bg-gray-100"
              >
                {account}
                <button
                  type="button"
                  onClick={() => handleCompetitorAccountRemove(index)}
                  className="ml-2 text-gray-500 hover:text-gray-700"
                >
                  ×
                </button>
              </span>
            ))}
          </div>
        </div>

        <button
          type="submit"
          className="w-full px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
        >
          Save Changes
        </button>
      </form>
    </div>
  );
}; 